import PaymentMethodForm from './PaymentMethodForm';

export default PaymentMethodForm;
